import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CONFIRMATION_FEATURE_KEY, State, ConfirmationPartialState } from './confirmation.reducer';

export const getConfirmationState = createFeatureSelector< State>(
  CONFIRMATION_FEATURE_KEY
);

export const getCurrentConfirmation = createSelector(
  getConfirmationState,
  (state: State) => state.current
);
export const getLastConfirmation = createSelector(
  getConfirmationState,
  (state: State) => state.last
);
